import { render, staticRenderFns } from "./scorecard-standard-orders.vue?vue&type=template&id=17b74298&scoped=true"
import script from "./scorecard-standard-orders.vue?vue&type=script&lang=js"
export * from "./scorecard-standard-orders.vue?vue&type=script&lang=js"
import style0 from "./scorecard-standard-orders.vue?vue&type=style&index=0&id=17b74298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b74298",
  null
  
)

export default component.exports